import style from './Title.module.sass'

export const Title: React.FunctionComponent = ({ children }) => {
	return <h2 className={style.title}>{children}</h2>
}
